import * as UAParser from 'ua-parser-js';
import IResult = IUAParser.IResult;

let _supportsPassive = null;
export function supportsPassive() {
    if (_supportsPassive !== null) {
        return _supportsPassive;
    }

    // Test via a getter in the options object to see if the passive property is accessed
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: () => {
          _supportsPassive = true;
        },
      });
      window.addEventListener('test', null, opts);
    } catch (e) {
        // Ignore
    }

    return _supportsPassive;
}

export function isIOSDevice(userAgent: string): boolean {
    return /iPad|iPhone|iPod/.test(userAgent);
}

// FIXME toto treba prerobit v novej appke, aby posielala cez header a nie cookie
// lebo Chrome zdiela cookies medzi webview a browserom a potom si browser mysli ze je appka
export function isAndroidApp(): boolean {
    return (
        typeof document !== 'undefined' &&
        document.cookie.replace(
            /(?:(?:^|.*;\s*)mobile_app\s*=\s*([^;]*).*$)|^.*$/,
            '$1') === 'android'
    );
}

let _supportsEmoji = null;
const EMOJIS_TO_TEST = [ '\ud83d\udc28', '\ud83d\ude42' ];
export function supportsEmoji() {
    if (_supportsEmoji !== null) {
        return _supportsEmoji;
    }

    // NodeJS supports emoji
    if (typeof window === 'undefined') {
        return _supportsEmoji = true;
    }

    // Ignore windows emoji support
    if (!window.navigator.platform || window.navigator.platform.indexOf('Win') !== -1) {
        return _supportsEmoji = false;
    }

    const node = window.document.createElement('canvas');

    const ctx = node.getContext('2d');
    if (!ctx) {
        return _supportsEmoji = false;
    }

    ctx.fillStyle = '#f00';
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.font = '32px Arial';

    _supportsEmoji = true;
    EMOJIS_TO_TEST.forEach((emoji) => {
        ctx.clearRect(0, 0, node.width, node.height);
        ctx.fillText(emoji, 0, 0);
        _supportsEmoji = _supportsEmoji && ctx.getImageData(0, 0, 1, 1).data[0] !== 0;
    });

    return _supportsEmoji;
}

/*
 * V niektorych verziach chrome na androide zamrza screen pre vyber fotky na upload
 */
export function hasBuggySelectImages(userAgent: string): boolean {
    const ua = new UAParser(userAgent).getResult();

    return (
        // na androide
        ua && ua.os && ua.os.name === 'Android' &&
        // v browseri aj appke
        ua.browser && ['Chrome', 'Chrome WebView'].indexOf(ua.browser.name) >= 0 &&
        // 24.4.2018: robi chrome 66 (stable) aj chrome 67 (dev channel)
        ua.browser.version && /^6[67]\./.test(ua.browser.version) &&
        // vybrani vyrobcovia, alebo ak nevieme naparsovat vyrobcu
        ua.device && (!ua.device.vendor || ['Huawei', 'Samsung', 'Lenovo', 'LG'].indexOf(ua.device.vendor) >= 0)
    );
}

export function hasBuggyPhotoUploadInput(userAgent: string): boolean {
    const ua = new UAParser(userAgent).getResult();

    const isAndroidBrowser = (
        // na androide 4.4
        ua && ua.os && ua.os.name === 'Android' && ua.os.version && ua.os.version.startsWith('4.4') &&
        // v appke so starym web view
        ua.browser && ['Android Browser'].indexOf(ua.browser.name) >= 0
    );
    if (!isAndroidBrowser) {
        return false;
    }

    return isAndroidApp();
}
